// src/components/apps/coleco/ColecoDescriptionsTab.js
import * as React from 'react';
import Box from '@mui/material/Box';

import * as Util from '../../../Util';
import EditorTabPanel from '../../common/editor/EditorTabPanel';
import EditorTextField from '../../common/editor/EditorTextField';

// i18n
import { useI18n } from '../../../i18n/I18nContext';

function KeypadField(props) {
  const {
    label,
    keyName,
    object,
    setObject
  } = props;

  let val = '';
  if (object.props.descriptions) {
    val = object.props.descriptions[keyName];
    if (!val) {
      val = '';
    }
  }

  const setValue = (str) => {
    let descs = object.props.descriptions;
    if (!descs) {
      descs = {};
    }

    if (Util.isEmptyString(str)) {
      delete descs[keyName];
    } else {
      descs[keyName] = str;
    }

    const props = { ...object.props, descriptions: descs };
    setObject({ ...object, props });
  };

  return (
    <div>
      <EditorTextField
        sx={{ width: '30ch' }}
        label={label}
        onDropText={(text) => { setValue(text); }}
        onChange={(e) => { setValue(e.target.value); }}
        value={Util.asString(val)}
      />
    </div>
  );
}

export default function ColecoDescriptionsTab(props) {
  const {
    tabValue,
    tabIndex,
    setObject,
    object
  } = props;

  const { t } = useI18n();

  const isRoller = object.props.controlsMode === 3;
  const isSuper = object.props.controlsMode === 1;
  const isDriving = object.props.controlsMode === 2;

  // Labels dinâmicos dos botões de fogo
  let firelLabelKey = 'colecoDescFireLeft';
  if (isDriving) {
    firelLabelKey = 'colecoDescGasButton';
  } else if (isSuper) {
    firelLabelKey = 'colecoDescYellowButton';
  }

  let firerLabelKey = 'colecoDescFireRight';
  if (isDriving) {
    firerLabelKey = 'colecoDescBrakeButton';
  } else if (isSuper) {
    firerLabelKey = 'colecoDescOrangeButton';
  }

  const firelLabel = t(firelLabelKey);
  const firerLabel = t(firerLabelKey);

  return (
    <EditorTabPanel value={tabValue} index={tabIndex}>
      <Box sx={{ m: 1.5 }}>
        {t('colecoDescIntro')}
      </Box>
      <KeypadField label={t('colecoDescKeypad1')} keyName="1" object={object} setObject={setObject} />
      <KeypadField label={t('colecoDescKeypad2')} keyName="2" object={object} setObject={setObject} />
      <KeypadField label={t('colecoDescKeypad3')} keyName="3" object={object} setObject={setObject} />
      <KeypadField label={t('colecoDescKeypad4')} keyName="4" object={object} setObject={setObject} />
      <KeypadField label={t('colecoDescKeypad5')} keyName="5" object={object} setObject={setObject} />
      <KeypadField label={t('colecoDescKeypad6')} keyName="6" object={object} setObject={setObject} />
      <KeypadField label={t('colecoDescKeypad7')} keyName="7" object={object} setObject={setObject} />
      <KeypadField label={t('colecoDescKeypad8')} keyName="8" object={object} setObject={setObject} />
      <KeypadField label={t('colecoDescKeypad9')} keyName="9" object={object} setObject={setObject} />
      <KeypadField label={t('colecoDescKeypadStar')} keyName="*" object={object} setObject={setObject} />
      <KeypadField label={t('colecoDescKeypad0')} keyName="0" object={object} setObject={setObject} />
      <KeypadField label={t('colecoDescKeypadHash')} keyName="#" object={object} setObject={setObject} />
      <KeypadField label={firelLabel} keyName="firel" object={object} setObject={setObject} />
      <KeypadField label={firerLabel} keyName="firer" object={object} setObject={setObject} />
      {isRoller && (
        <KeypadField
          label={t('colecoDescLeftFire2p')}
          keyName="firel2"
          object={object}
          setObject={setObject}
        />
      )}
      {isRoller && (
        <KeypadField
          label={t('colecoDescRightFire2p')}
          keyName="firer2"
          object={object}
          setObject={setObject}
        />
      )}
      {isSuper && (
        <KeypadField
          label={t('colecoDescPurpleButton')}
          keyName="purple"
          object={object}
          setObject={setObject}
        />
      )}
      {isSuper && (
        <KeypadField
          label={t('colecoDescBlueButton')}
          keyName="blue"
          object={object}
          setObject={setObject}
        />
      )}
    </EditorTabPanel>
  );
}